<template>
  <div class="insulationMaterial" :key="'insulationMaterial' + $store.state.calculatorData.merchandiserViewToggleState">
    <div class="row">
      <div class="col-md-7">
        <h2>{{ $t(`insulationMaterial.title`)}}</h2>
      </div>
      <div class="col-md-5 md-align-right" v-if="elementForm !== ''">
        <p>({{$t(`globals.currentSelectedForm`)}} <strong> {{$t(`elementForm.`+ elementForm +`.pdfTitle`)}}</strong>)</p>
      </div>
    </div>

    <b-button @click="explanationClick()" v-b-toggle.explanation-content-insulationMaterial variant="primary" class="explanation"> <span v-html="$t(`globals.explanation`)"></span></b-button>
    <b-collapse id="explanation-content-insulationMaterial" class="explanation-content">
      <b-card>
        <p v-html="$t(`insulationMaterial.infoText`)"></p>
        <p class="d-md-none font-size-small radio-info-text">
          <b-badge variant="warning">i</b-badge>
          Wählen für weitere Informationen
        </p>
      </b-card>
    </b-collapse>
    <div class="radio-tile-group columns-3">
      <StoRadio step="insulationMaterial" type="eps" />
      <StoRadio step="insulationMaterial" type="epsAndPlaster" />
      <StoRadio step="insulationMaterial" type="foamglas" />
    </div>
  <StepNavi thisPage="0" :key="`navi_tab1_`+$store.state.calculatorData.calculatorPages[1].disabled"/>
  </div>
</template>

<script>
import StoRadio from './StoRadio.vue'
import StepNavi from './StepNavi.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'InsulationMaterial',
  components: {
    StoRadio,
    StepNavi
  },
  computed: {
    ...mapGetters([
      'disabledStatusTab1',
      'elementForm'
    ])
  },
  data () {
    return {
      textTriggerOpen: false
    }
  },
  methods: {
    explanationClick: function () {
      if (this.textTriggerOpen) {
        this.textTriggerOpen = false
      } else {
        this.$root.$children['0'].userDidAction = true
        this.textTriggerOpen = true
        let tabName = 'insulationMaterial'
        let gtmEventLabel = this.$t(tabName + '.virtualPageTitle')
        let virtualPageURL = '/' + this.$t(tabName + '.virtualPageURL')
        let virtualPageTitle = this.$t(tabName + '.virtualPageTitle')
        this.$root.$children['0'].globalGTMFkt('JKK-Events', 'Erläuterung', 'Button', gtmEventLabel, '', virtualPageURL, virtualPageTitle)
      }
    }
  },
  mounted: function () {
    // console.log('--- InsulationMaterial rendert ---')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
